"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const UploadedDocuments_1 = __importDefault(require("@Components/OverclaimView/DocumentForms/UploadDocumentsForm/UploadedDocumentsList/UploadedDocuments"));
const UploadedDocumentsList = (props) => (react_1.default.createElement("ul", null, props.uploadedFiles.map((file, index) => (react_1.default.createElement(UploadedDocuments_1.default, Object.assign({ key: `${file.name}-${file.lastModified}` }, props, { file: file, index: index }))))));
exports.default = UploadedDocumentsList;
